import { InternetMonitoramento } from './internet-monitoramento.model';
import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { StorageMonitoramento } from './storage-monitoramento.model';
import { BancoDadosMonitoramento } from './banco-dados-monitoramento.model';
import { AplicacaoMonitoramento } from './aplicacao-monitoramento.model';

export class ConversorMonitoramento extends AplicacaoMonitoramento {
  bancoDados: BancoDadosMonitoramento;
  storage: StorageMonitoramento;

  public static getAtivos(monitoramento: ConversorMonitoramento): AtivoMonitoramentoDetalhado[] {
    return [
      InternetMonitoramento.getAtivo(monitoramento.internet),
      BancoDadosMonitoramento.getAtivo(monitoramento.bancoDados),
      StorageMonitoramento.getAtivo(monitoramento.storage),
    ];
  }
}
